import React from "react";
import { ReportName } from "types/gql-types";
import { ReportTable } from "./report-table";

export const ApplicationDob: React.FC = () => (
  <ReportTable reportName={ReportName.INTEREST_DOB} includeTitle />
);
